'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Response = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _arrayClean = require('d2-utilizr/lib/arrayClean');

var _arrayClean2 = _interopRequireDefault(_arrayClean);

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

var _arrayInsert = require('d2-utilizr/lib/arrayInsert');

var _arrayInsert2 = _interopRequireDefault(_arrayInsert);

var _arraySort = require('d2-utilizr/lib/arraySort');

var _arraySort2 = _interopRequireDefault(_arraySort);

var _arrayUnique = require('d2-utilizr/lib/arrayUnique');

var _arrayUnique2 = _interopRequireDefault(_arrayUnique);

var _objectApplyIf = require('d2-utilizr/lib/objectApplyIf');

var _objectApplyIf2 = _interopRequireDefault(_objectApplyIf);

var _clone = require('d2-utilizr/lib/clone');

var _clone2 = _interopRequireDefault(_clone);

var _isBoolean = require('d2-utilizr/lib/isBoolean');

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _isDefined = require('d2-utilizr/lib/isDefined');

var _isDefined2 = _interopRequireDefault(_isDefined);

var _isEmpty = require('d2-utilizr/lib/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _isNumber = require('d2-utilizr/lib/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _isNumeric = require('d2-utilizr/lib/isNumeric');

var _isNumeric2 = _interopRequireDefault(_isNumeric);

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

var _getParseMiddleware = require('../util/getParseMiddleware');

var _getParseMiddleware2 = _interopRequireDefault(_getParseMiddleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Response = exports.Response = function Response(refs, config) {
    var t = this;

    config = (0, _isObject2.default)(config) ? config : {};

    var appManager = refs.appManager,
        indexedDbManager = refs.indexedDbManager,
        i18nManager = refs.i18nManager;
    var _refs$api = refs.api,
        ResponseHeader = _refs$api.ResponseHeader,
        ResponseRow = _refs$api.ResponseRow;


    var i18n = i18nManager.get();

    var booleanMap = {
        '0': i18n.no || 'No',
        '1': i18n.yes || 'Yes'
    };

    var OUNAME = 'ouname',
        OU = 'ou';

    var DEFAULT_COLLECT_IGNORE_HEADERS = ['psi', 'ps', 'eventdate', 'longitude', 'latitude', 'ouname', 'oucode', 'eventdate', 'eventdate'];

    var DEFAULT_PREFIX_IGNORE_HEADERS = ['dy'].concat(DEFAULT_COLLECT_IGNORE_HEADERS);

    //DIMENSIONS      ITEMS    -> COLLECT         PREFIX

    //- required                        V               V           no             no

    //- legendSet                       V               V           no             no
    //- !dimensions                     x               x           yes            yes

    //- optionset, !dimensions          x               x           yes            yes
    //- optionset                       V               x           no             yes

    // functions
    var isPrefixHeader = function isPrefixHeader(header, dimensions) {
        if ((0, _arrayContains2.default)(DEFAULT_PREFIX_IGNORE_HEADERS, header.name)) {
            return false;
        }

        return (0, _isEmpty2.default)(dimensions);
    };

    var isCollectHeader = function isCollectHeader(header, dimensions) {
        if ((0, _arrayContains2.default)(DEFAULT_COLLECT_IGNORE_HEADERS, header.name)) {
            return false;
        }

        return (0, _isEmpty2.default)(dimensions);
    };

    var getHeader = function getHeader(name) {
        return t.headers.find(function (header) {
            return header.name === name;
        });
    };
    var hasHeader = function hasHeader(name) {
        return getHeader(name) !== undefined;
    };

    t.getPrefixedId = function (id, prefix) {
        return (prefix || '') + '_' + id;
    };

    t.getSortedUniqueRowIdStringsByHeader = function (header) {
        var parseByType = (0, _getParseMiddleware2.default)(header.valueType);
        var parseString = (0, _getParseMiddleware2.default)('STRING');

        return (0, _arraySort2.default)((0, _arrayClean2.default)((0, _arrayUnique2.default)(t.rows.map(function (responseRow) {
            return parseByType(responseRow.getAt(header.index));
        })))).map(function (id) {
            return parseString(id);
        });
    };

    t.getNameByIdsByValueType = function (id, valueType) {
        if (valueType === 'BOOLEAN') {
            return booleanMap[id];
        }

        return id;
    };

    t.optionCodeIdMap = function () {
        var dimensions = config.metaData.dimensions;
        var items = config.metaData.items;
        var map = {};

        config.headers.filter(function (header) {
            return (0, _isString2.default)(header.optionSet);
        }).forEach(function (header) {
            var optionIds = dimensions[header.name];

            var mapByDimension = optionIds.map(function (id) {
                return _defineProperty({}, items[id].code, id);
            }).reduce(function (map, obj) {
                return _extends(map, obj);
            }, {});

            map[header.name] = mapByDimension;
        });

        return map;
    }();

    // headers
    t.headers = (config.headers || []).map(function (header, index) {
        var dimensions = config.metaData.dimensions;

        var prefixConfig = isPrefixHeader(header, dimensions[header.name]) ? { isPrefix: true } : {};
        var collectConfig = isCollectHeader(header, dimensions[header.name]) ? { isCollect: true } : {};

        return new ResponseHeader(refs, header, _extends({}, prefixConfig, collectConfig, { index: index }));
    });

    // rows
    t.rows = function () {
        var headersWithOptionSet = t.headers.filter(function (header) {
            return header.optionSet;
        });
        var rows = config.rows;

        if (headersWithOptionSet.length) {
            rows = rows.slice();

            // replace option code with option uid
            headersWithOptionSet.forEach(function (header) {
                rows.forEach(function (row) {
                    var id = t.optionCodeIdMap[header.name][row[header.index]];

                    if (id) {
                        row[header.index] = id;
                    }
                });
            });
        }
        // map to ResponseRow
        return rows.map(function (row) {
            return ResponseRow(refs, row);
        });
    }();

    // metadata
    t.metaData = function () {
        var metaData = _extends({}, config.metaData);

        var dimensions = metaData.dimensions,
            items = metaData.items;

        // populate metaData dimensions and items
        t.headers.filter(function (header) {
            return !(0, _arrayContains2.default)(DEFAULT_COLLECT_IGNORE_HEADERS, header.name);
        }).forEach(function (header) {
            var ids;

            // collect row values
            if (header.isCollect) {
                ids = t.getSortedUniqueRowIdStringsByHeader(header);
                dimensions[header.name] = ids;
            } else {
                ids = dimensions[header.name];
            }

            if (header.isPrefix) {

                // create prefixed dimensions array
                dimensions[header.name] = ids.map(function (id) {
                    return t.getPrefixedId(id, header.name);
                });

                // create items
                if (header.optionSet) {
                    dimensions[header.name].forEach(function (prefixedId, index) {
                        var id = ids[index];
                        var optionSet = header.optionSet;

                        var name = indexedDbManager.getCachedOptionName(id, optionSet);

                        items[prefixedId] = { name: metaData.items[name] ? metaData.items[name].name : name };
                    });
                } else {
                    dimensions[header.name].forEach(function (prefixedId, index) {
                        var id = ids[index];
                        var valueType = header.valueType;

                        var name = t.getNameByIdsByValueType(id, valueType);

                        items[prefixedId] = { name: name };
                    });
                }
            }
        });

        // for events, add items from 'ouname'
        if (hasHeader(OUNAME) && hasHeader(OU)) {
            var ounameHeaderIndex = getHeader(OUNAME).getIndex();
            var ouHeaderIndex = getHeader(OU).getIndex();

            for (var i = 0, row, ouId, ouName, item; i < t.rows.length; i++) {
                row = t.rows[i];
                ouId = row.getAt(ouHeaderIndex);

                if (items[ouId] !== undefined) {
                    continue;
                }

                ouName = row.getAt(ounameHeaderIndex);

                items[ouId] = {
                    name: ouName
                };
            }
        }

        return metaData;
    }();

    // transient
    t.nameHeaderMap = function () {
        var map = {};

        t.headers.forEach(function (header) {
            map[header.name] = header;
        });

        return map;
    }();

    // uninitialized
    t.idValueMap;
    t.sortedRows;

    t.getRefs = function () {
        return refs;
    };
};

Response.prototype.sortOrganisationUnitsHierarchy = function () {
    var _this = this;

    var organisationUnits = this.metaData.dimensions.ou;

    var _loop = function _loop(i) {
        var organisationUnit = organisationUnits[i],
            hierarchyPrefix = _this.metaData.ouHierarchy[organisationUnit],
            hierarchyIds = [organisationUnit],
            hierarchyNames = [];

        hierarchyPrefix.split('/').reverse().forEach(function (ouId) {
            hierarchyIds.unshift(ouId);
        });

        hierarchyIds.map(function (ouId) {
            if (_this.metaData.items[ouId]) {
                hierarchyNames.push(_this.metaData.items[ouId].name);
            }
        });

        organisationUnits[i] = {
            id: organisationUnit,
            fullName: hierarchyNames.join(' / ')
        };
    };

    for (var i = 0; i < organisationUnits.length; ++i) {
        _loop(i);
    }

    (0, _arraySort2.default)(organisationUnits, null, 'fullName');

    this.metaData.dimensions.ou = organisationUnits.map(function (ou) {
        return ou.id;
    });
};

Response.prototype.clone = function () {
    var refs = this.getRefs();

    var Response = refs.api.Response;


    return new Response(refs, this);
};

Response.prototype.getHeaderByName = function (name) {
    return this.nameHeaderMap[name];
};

Response.prototype.getHeaderByIndex = function (index) {
    return this.headers[index];
};

Response.prototype.getHeaderIndexByName = function (name) {
    var header = this.nameHeaderMap[name] || {};

    return header.index;
};

Response.prototype.getOptionSetHeaders = function () {
    return t.headers.filter(function (header) {
        return (0, _isString2.default)(header.optionSet) || isArray(header.optionSet);
    });
};

Response.prototype.getNameById = function (id) {
    return (this.metaData.items[id] || {}).name || id;
};

Response.prototype.getHierarchyNameById = function (id, isHierarchy, isHtml) {
    var metaData = this.metaData,
        name = '';

    var items = metaData.items;

    if (isHierarchy && metaData.ouHierarchy.hasOwnProperty(id)) {
        var a = (0, _arrayClean2.default)(metaData.ouHierarchy[id].split('/'));

        a.forEach(function (id) {
            name += (isHtml ? '<span class="text-weak">' : '') + items[id].name + (isHtml ? '</span>' : '') + ' / ';
        });
    }

    return name;
};

Response.prototype.getIdsByDimensionName = function (dimensionName) {
    return this.metaData.dimensions ? this.metaData.dimensions[dimensionName] || [] : [];
};

Response.prototype.addMetaDataItems = function (items) {
    this.metaData.items = _extends(this.metaData.items, items);
};

Response.prototype.addOuHierarchyDimensions = function () {
    var t = this;

    var headers = t.headers,
        ouHierarchy = t.metaData.ouHierarchy,
        rows = t.rows,
        ouIndex,
        numLevels = 0,
        initArray = [],
        newHeaders = [],
        ou = 'ou',
        a;

    if (!ouHierarchy) {
        return;
    }

    // get ou index
    for (var i = 0, header; i < headers.length; i++) {
        if (headers[i].name === ou) {
            ouIndex = i;
            break;
        }
    }

    // get numLevels
    for (var i = 0; i < rows.length; i++) {
        numLevels = Math.max(numLevels, (0, _arrayClean2.default)(ouHierarchy[rows[i][ouIndex]].split('/')).length);
    }

    // init array
    for (var i = 0; i < numLevels; i++) {
        initArray.push('');
    }

    // extend rows
    for (var i = 0, row, ouArray; i < rows.length; i++) {
        row = rows[i];
        ouArray = (0, _objectApplyIf2.default)((0, _arrayClean2.default)(ouHierarchy[row[ouIndex]].split('/')), (0, _clone2.default)(initArray));

        (0, _arrayInsert2.default)(row, ouIndex, ouArray);
    }

    // create new headers
    for (var i = 0; i < numLevels; i++) {
        newHeaders.push({
            column: 'Organisation unit',
            hidden: false,
            meta: true,
            name: 'ou',
            type: 'java.lang.String'
        });
    }

    (0, _arrayInsert2.default)(headers, ouIndex, newHeaders);

    return t;
};

Response.prototype.printResponseCSV = function () {
    var t = this;

    var headers = t.headers,
        items = t.metaData.items,
        rows = t.rows,
        csv = '',
        alink;

    // headers
    for (var i = 0; i < headers.length; i++) {
        csv += '"' + headers[i].column + '"' + (i < headers.length - 1 ? ',' : '\n');
    }

    // rows
    for (var i = 0; i < rows.length; i++) {
        for (var j = 0, val, isMeta; j < rows[i].length; j++) {
            val = rows[i][j];
            isMeta = headers[j].meta;

            csv += '"' + (isMeta && items[val] && (0, _isString2.default)(items[val].name) ? items[val].name : val) + '"';
            csv += j < rows[i].length - 1 ? ',' : '\n';
        }
    }

    alink = document.createElement('a');
    alink.setAttribute('href', 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv));
    alink.setAttribute('download', 'data.csv');
    alink.click();
};

Response.prototype.getFilteredHeaders = function (names) {
    return this.headers.filter(function (header) {
        return (0, _arrayContains2.default)(names, header.name);
    });
};

Response.prototype.getOrganisationUnitsIds = function () {
    return this.metaData.dimensions.ou;
};

// dep 1
Response.prototype.getHeaderNameByIndex = function (index) {
    return this.getHeaderByIndex(index).name;
};

Response.prototype.getHeaderIndexOrder = function (dimensionNames) {
    var _this2 = this;

    return dimensionNames.map(function (name) {
        return _this2.getHeaderIndexByName(name);
    });
};

Response.prototype.getIdsByDimensionNames = function (dimensionName) {
    var _this3 = this;

    return (0, _arrayClean2.default)(dimensionName.reduce(function (ids, name) {
        return ids.concat(_this3.getIdsByDimensionName(name) || []);
    }, []));
};

Response.prototype.getItemName = function (id, isHierarchy, isHtml) {
    return this.getHierarchyNameById(id, isHierarchy) + this.getNameById(id);
};

Response.prototype.getRecordsByDimensionName = function (dimensionName) {
    var _this4 = this;

    var refs = this.getRefs(),
        Record = refs.api.Record;


    var ids = this.getIdsByDimensionName(dimensionName) || [],
        records = ids.map(function (id) {
        return new Record(refs, { id: id, name: _this4.getNameById(id) }).val();
    });

    return (0, _arrayClean2.default)(records);
};

Response.prototype.getValueHeader = function () {
    return this.getHeaderByName('value');
};

Response.prototype.getNumeratorHeader = function () {
    return this.getHeaderByName('numerator');
};

Response.prototype.getDenominatorHeader = function () {
    return this.getHeaderByName('denominator');
};

Response.prototype.getFactorHeader = function () {
    return this.getHeaderByName('factor');
};

Response.prototype.hasIdByDimensionName = function (id, dimensionName) {
    return (0, _arrayContains2.default)(this.getIdsByDimensionName(dimensionName), id);
};

// dep 2
Response.prototype.getValueHeaderIndex = function () {
    return this.getValueHeader() ? this.getValueHeader().getIndex() : null;
};

Response.prototype.getNumeratorHeaderIndex = function () {
    return this.getNumeratorHeader() ? this.getNumeratorHeader().getIndex() : null;
};

Response.prototype.getDenominatorHeaderIndex = function () {
    return this.getDenominatorHeader() ? this.getDenominatorHeader().getIndex() : null;
};

Response.prototype.getFactorHeaderIndex = function () {
    return this.getFactorHeader() ? this.getFactorHeader().getIndex() : null;
};

// dep 3
Response.prototype.getSortedRows = function () {
    if (this.sortedRows) {
        return this.sortedRows;
    }

    var valueHeaderIndex = this.getValueHeaderIndex();

    // filter
    var rows = this.rows.filter(function (row) {
        return (0, _isNumeric2.default)(row[valueHeaderIndex]);
    });

    // parse
    rows.forEach(function (row) {
        return row.toFloat(valueHeaderIndex);
    });

    // sort
    (0, _arraySort2.default)(rows, 'DESC', valueHeaderIndex);

    return this.sortedRows = rows;
};

Response.prototype.getIdValueMap = function (layout) {
    return this.idValueMap = this.getIdMap(layout, 'value');
};

Response.prototype.getIdDenominatorMap = function (layout) {
    return this.idDenominatorMap = this.getIdMap(layout, 'denominator');
};

Response.prototype.getIdNumeratorMap = function (layout) {
    return this.idNumeratorMap = this.getIdMap(layout, 'numerator');
};

Response.prototype.getIdFactorMap = function (layout) {
    return this.idFactorMap = this.getIdMap(layout, 'factor');
};

Response.prototype.getIdMap = function (layout, name) {
    var _this5 = this;

    var refs = this.getRefs(),
        ResponseRowIdCombination = refs.api.ResponseRowIdCombination,
        headerIndexOrder = (0, _arrayClean2.default)(this.getHeaderIndexOrder(layout.getDimensionNames())),
        idMap = {};


    this.rows.forEach(function (responseRow) {
        var idCombination = new ResponseRowIdCombination(refs),
            key = void 0,
            rowValue = void 0,
            header = void 0;

        headerIndexOrder.forEach(function (index) {
            header = _this5.getHeaderByIndex(index);
            rowValue = responseRow.getAt(index);
            key = header.isPrefix ? _this5.getPrefixedId(rowValue, header.name) : rowValue;

            idCombination.add(key);
        });

        responseRow.setIdCombination(idCombination);
        idMap[idCombination.get()] = responseRow.getAt(_this5.getHeaderByName(name).getIndex());
    });

    return idMap;
};

// dep 4
Response.prototype.getValue = function (param, layout) {
    var _getRefs = this.getRefs(),
        ResponseRowIdCombination = _getRefs.refs.api,
        id = param instanceof ResponseRowIdCombination ? param.get() : param;

    return this.getIdValueMap(layout)[id];
};

Response.prototype.getExtremalRows = function (limit, isTop, isBottom) {
    limit = (0, _isNumeric2.default)(limit) ? parseInt(limit) : 10;
    isTop = (0, _isBoolean2.default)(isTop) ? isTop : true;
    isBottom = (0, _isBoolean2.default)(isBottom) ? isBottom : true;

    var sortedRows = this.getSortedRows(),
        len = sortedRows.length;

    return [].concat(_toConsumableArray(isTop ? sortedRows.slice(0, limit) : []), _toConsumableArray(isBottom ? sortedRows.slice(len - limit, len) : []));
};

// dep 5
Response.prototype.getValues = function (paramArray, layout) {
    var _this6 = this;

    return (0, _arrayFrom2.default)(paramArray).map(function (param) {
        return _this6.getValue(param, layout);
    });
};
//# sourceMappingURL=Response.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/api/Response.js
 ** module id = 120
 ** module chunks = 0 1
 **/